import * as React from "react";
import { Helmet } from "react-helmet";
const productName = "App Center";
export default (
  <Helmet
    title={`Visual Studio ${productName} | iOS, Android, Xamarin & React Native`}
    meta={[
      {
        name: "description",
        content: `${productName} gives you faster release cycles, higher-quality apps and data to focus on what users want.`,
      },
    ]}
  />
);
